import React from "react";
import clsx from "clsx";

interface BadgeProps {
    text: string;
    color:
    | "blue"
    | "gray"
    | "red"
    | "green"
    | "yellow"
    | "indigo"
    | "purple"
    | "pink"
    | "orange"
    className?: string;
}

const Badge: React.FC<BadgeProps> = ({ text, color, className }) => {
    const base = "text-xs font-medium me-2 px-2.5 py-2 rounded-sm";
    const light = `bg-${color}-100 text-${color}-800`;
    const dark = `dark:bg-${color}-900 dark:text-${color}-300`;

    return (
        <span className={clsx(base, light, dark, className)}>
            {text}
        </span>
    );
};

export default Badge;
